export const COUNTRY_API = "https://restcountries.com/v3.1/all"; 